export const environment = {
  production: true,
  blobStorageUrl: 'https://sbceventsplatformprod.blob.core.windows.net',
  baseUrl: 'https://sbcconnect.com/',
};
